/**
 * @generated SignedSource<<d6cab56e3dbdd95c0c1c65ad48cdd859>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StatsigProvider_query$data = {
  readonly statsigInitializeResponse: {
    readonly customIDs: ReadonlyArray<{
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
    }> | null | undefined;
    readonly initialValues: string | null | undefined;
    readonly privateAttributes: any | null | undefined;
    readonly userID: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "StatsigProvider_query";
};
export type StatsigProvider_query$key = {
  readonly " $data"?: StatsigProvider_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatsigProvider_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StatsigProvider_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StatsigInitializeResponse",
      "kind": "LinkedField",
      "name": "statsigInitializeResponse",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StatsigCustomID",
          "kind": "LinkedField",
          "name": "customIDs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "initialValues",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "privateAttributes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "fa048e927502da2b807cb11aedeaa465";

export default node;
